const updates = [
  {
    time: '08:42',
    title: '某顶流歌手新专辑被指抄袭，工作室发声明否认',
    tag: '音乐圈',
    tagColor: 'bg-primary-500',
  },
  {
    time: '07:15',
    title: '某综艺节目录制现场嘉宾突发身体不适',
    tag: '综艺',
    tagColor: 'bg-accent-500',
  },
  {
    time: '06:30',
    title: '知名导演新片定档，主演阵容首次公开',
    tag: '影视',
    tagColor: 'bg-secondary-500',
  },
  {
    time: '05:18',
    title: '某网红被曝偷税漏税，相关部门介入调查',
    tag: '网红',
    tagColor: 'bg-primary-500',
  },
  {
    time: '04:02',
    title: '某男团成员被拍到与女粉丝私下见面引争议',
    tag: '偶像',
    tagColor: 'bg-accent-500',
  },
  {
    time: '02:45',
    title: '某电视剧因剧情争议被要求整改重拍',
    tag: '影视',
    tagColor: 'bg-secondary-500',
  },
  {
    time: '01:20',
    title: '某品牌发布会现场音响故障，艺人清唱救场',
    tag: '活动',
    tagColor: 'bg-primary-500',
  },
  {
    time: '00:55',
    title: '某女演员社交平台发文暗示即将退圈',
    tag: '明星',
    tagColor: 'bg-accent-500',
  },
  {
    time: '00:08',
    title: '深夜爆料：某知名经纪人被曝私吞艺人收入',
    tag: '幕后',
    tagColor: 'bg-secondary-500',
  },
];

export default function UpdatesSection() {
  return (
    <section id="updates" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-3xl mx-auto">
          <div className="flex items-center justify-between mb-8">
            <div>
              <h2 className="font-heading text-2xl md:text-3xl font-black text-foreground-950">实时快讯</h2>
              <p className="text-sm text-foreground-600 mt-1">24小时不间断更新的最新动态</p>
            </div>
            <span className="inline-flex items-center gap-1.5 text-xs text-primary-600 font-medium whitespace-nowrap">
              <span className="w-1.5 h-1.5 rounded-full bg-primary-500 animate-pulse"></span>
              LIVE
            </span>
          </div>

          <div className="relative">
            <div className="absolute left-[19px] top-2 bottom-2 w-0.5 bg-background-200/80"></div>
            <div className="space-y-6">
              {updates.map((item, i) => (
                <div key={i} className="relative flex items-start gap-5 pl-12">
                  <div className="absolute left-0 top-1 w-[38px] h-[38px] rounded-full bg-background-50 border-2 border-background-200 flex items-center justify-center flex-shrink-0 z-10">
                    <span className="text-[10px] font-black text-foreground-600 whitespace-nowrap">{item.time}</span>
                  </div>
                  <div className="flex-1 bg-background-50 border border-background-200/60 rounded-xl p-4 hover:border-primary-300 transition-all cursor-pointer group">
                    <div className="flex items-center gap-2 mb-1.5">
                      <span className={`px-2 py-0.5 rounded-full text-[10px] font-bold text-background-50 ${item.tagColor} whitespace-nowrap`}>
                        {item.tag}
                      </span>
                      <span className="text-xs text-foreground-500">{item.time}</span>
                    </div>
                    <h3 className="text-sm font-bold text-foreground-900 leading-snug group-hover:text-primary-600 transition-colors">
                      {item.title}
                    </h3>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}